import { ClientCategorisation } from '@/constants';
import { fastApi } from '@/services/api';
import type { NationalClientIdentifierType } from '@/utils/national-client-identifier';

const PATH = 'v1/countries';

export type CountryAmlRisk = 'low' | 'medium' | 'high' | 'prohibited';
export type CountryProductType = 'DATED_FUTURE' | 'EQUITY_FUTURE' | 'SPOT';
type CountryRequiredDocumentIds = 'tax';
export type CountryPostalCodeUse = 'none' | 'optional' | 'required';

export type CountryAllowedProducts = {
  [ClientCategorisation.PROFESSIONAL]: CountryProductType[];
  [ClientCategorisation.RETAIL]: CountryProductType[];
};

export type Country = {
  allowedCitizenship: boolean;
  allowedProducts?: CountryAllowedProducts;
  allowedResidency: boolean;
  alpha3: string;
  amlRisk: CountryAmlRisk;
  eea: boolean;
  eu?: boolean;
  name: string;
  name_de: string;
  nciPriority: NationalClientIdentifierType[];
  noFiatTransfers: boolean;
  phoneCode: Array<string> | string;
  postalCodeUse?: CountryPostalCodeUse;
  requiredDocumentIds?: CountryRequiredDocumentIds[];
};

export type CountriesRecord = Record<string, Country>;

type CountriesGetResponse = CountriesRecord;

export const getCountries = async () => {
  return fastApi.get(PATH).json<CountriesGetResponse>();
};

export const getCountryPrimaryPhoneCode = (country: Country) => {
  if (typeof country.phoneCode === 'string') return country.phoneCode;
  if (country.phoneCode.length === 1) return country.phoneCode[0];

  return undefined;
};
